import React from 'react';
import { isMobile } from "is-mobile";

import './style.css';
import { COLORS } from '../../constants';
import { getContrast } from '../../helpers/commonHelper';

const Footer = ({campaign, campaignColor }) => {
  const companyName = campaign.companyName || "VideoPeel";
  const companyEmail = campaign.companyEmail || "info@videopeel.com";
  const companyWebsiteUrl = campaign.companyWebsiteUrl || "https://www.videopeel.com/";
  const contrastColor = campaign && campaign.banner
                        ? getContrast(campaign.banner)
                        : COLORS.black;

  const renderTextBreak = isMobile();

  return (
    <div className='footer'>
      <p>
        Powered by{" "}
        <a
          target="_blank"
          style={{ color: contrastColor === COLORS.black ? COLORS.black : campaign.banner }}
          href={companyWebsiteUrl}>{companyName}
        </a>{" "}
        &copy;{(new Date().getFullYear())} All Rights Reserved.
        {renderTextBreak ? < br/> : " "}
        We are here to help! {companyEmail}</p>
    </div>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js